import {Component, OnInit} from '@angular/core';

@Component({
    template: require('./user-list.component.pug'),
    styles: [require('./user-list.component.css')]
})
export class UserListComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/users/user-list.component.ts